import { createSlice } from '@reduxjs/toolkit'

export const addedJobSlice = createSlice({
  name: 'addedJob',
  initialState: {
    arr: {}
  },
  reducers: {

    add: (state, action) => {
      switch  (action.payload[0]) {
        case 0:
          state.arr['machineId'] = action.payload[1];
          break;
        case 1:
          state.arr['operationTypeId'] = action.payload[1];
          break;
        case 2:
          state.arr['workOrderId'] = action.payload[1];
          break;
        case 3:
          state.arr['date'] = action.payload[1];
          break;
        case 4:
          state.arr['employeeId'] = action.payload[1];
          break;
        case 5:
          state.arr['volume'] = action.payload[1];
          break;
        case 6:
          state.arr['sum'] = action.payload[1];
          break;
        case 7:
          state.arr['workOrderName'] = action.payload[1];
          break;
        case 8:
          state.arr['realMachineId'] = action.payload[1];
          break;
        case 9:
          state.arr['workOrderDate'] = action.payload[1];
          break;
      }
     
    },
  },
})

// Action creators are generated for each case reducer function
export const { add } = addedJobSlice.actions

export default addedJobSlice.reducer